import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AssetMismatch } from 'app/profile/models/generic.model';
import { TslDialogRef, TSL_DIALOG_DATA } from '@tesla/ng-tds';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'asset-mismatch',
  templateUrl: './asset-mismatch.component.html',
  styleUrls: ['./asset-mismatch.component.scss']
})
export class AssetMismatchComponent implements OnInit {
  public errortable: AssetMismatch[] = [];

  assetErrorColumns: string[] = ['assetCode', 'assetStatus', 'partNumbers', 'cmtType'];
  assetMismatchDataSource: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  constructor(
    public dialogRef: TslDialogRef<AssetMismatchComponent>,
    @Inject(TSL_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.data.forEach(element => {
      var pns = element.partNumbers.split(',').filter(function (el) {
        return el != "";
      });

      var dns = element.demandTypes.split(',').filter(function (el) {
        return el != "";
      });

      var pnsWithDemandTypes = pns.map((e: string, i: string | number) => e + '(' + dns[i] + ')');

      var cmtType = element.assetStatus == "notactive" ? "Asset Disposal Request" : "Asset Status Mismatch";

      this.errortable.push(new AssetMismatch(element.assetCode, element.assetStatus, pnsWithDemandTypes.join(','), '', cmtType));
    });

    this.assetMismatchDataSource.next([...this.errortable]);
  }

  onConfirm() {
    this.dialogRef.close({ event: 'confirm', data: true });
  }

  onCancel() {
    this.dialogRef.close({ event: 'close', data: false });
  }
}
